import React, { useEffect, useState } from "react";

interface Petal {
  id: number;
  x: number;
  y: number;
  size: number;
  rotation: number;
  delay: number;
  duration: number;
  opacity: number;
}

export const LotusPetals = React.memo(() => {
  const [petals, setPetals] = useState<Petal[]>([]);

  useEffect(() => {
    const generatePetals = () => {
      const newPetals: Petal[] = [];
      for (let i = 0; i < 12; i++) {
        newPetals.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: 20 + Math.random() * 30,
          rotation: Math.random() * 360,
          delay: Math.random() * 5,
          duration: 8 + Math.random() * 6,
          opacity: 0.15 + Math.random() * 0.2,
        });
      }
      setPetals(newPetals);
    };

    generatePetals();
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {petals.map((petal) => (
        <div
          key={petal.id}
          className="absolute animate-lotus-float"
          style={{
            left: `${petal.x}%`,
            top: `${petal.y}%`,
            width: petal.size,
            height: petal.size,
            opacity: petal.opacity,
            animationDelay: `${petal.delay}s`,
            animationDuration: `${petal.duration}s`,
            transform: `rotate(${petal.rotation}deg)`,
          }}
        >
          {/* Lotus petal SVG */}
          <svg
            viewBox="0 0 50 50"
            className="w-full h-full"
            style={{ filter: "blur(0.5px)" }}
          >
            <defs>
              <linearGradient id={`petal-gradient-${petal.id}`} x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="hsl(var(--gold))" stopOpacity="0.6" />
                <stop offset="50%" stopColor="hsl(var(--saffron-light))" stopOpacity="0.4" />
                <stop offset="100%" stopColor="hsl(var(--gold-light))" stopOpacity="0.2" />
              </linearGradient>
            </defs>
            <path
              d="M25 5 C35 15, 40 25, 40 35 C40 45, 30 48, 25 48 C20 48, 10 45, 10 35 C10 25, 15 15, 25 5"
              fill={`url(#petal-gradient-${petal.id})`}
            />
          </svg>
        </div>
      ))}

      {/* Glowing orbs */}
      <div 
        className="absolute top-1/4 left-1/5 w-32 h-32 rounded-full animate-glow-pulse"
        style={{
          background: "radial-gradient(circle, hsl(var(--gold) / 0.15) 0%, transparent 70%)",
          animationDelay: "0s",
        }}
      />
      <div 
        className="absolute top-1/2 right-1/4 w-48 h-48 rounded-full animate-glow-pulse"
        style={{
          background: "radial-gradient(circle, hsl(var(--saffron) / 0.1) 0%, transparent 70%)",
          animationDelay: "2s",
        }}
      />
      <div 
        className="absolute bottom-1/3 left-1/3 w-40 h-40 rounded-full animate-glow-pulse"
        style={{
          background: "radial-gradient(circle, hsl(var(--gold-light) / 0.12) 0%, transparent 70%)",
          animationDelay: "4s",
        }}
      />
    </div>
  );
});

LotusPetals.displayName = "LotusPetals";
